import axios from "axios";

export const sendMail = async (data: {
  email: string;
  message: string;
  date: { startDate: string | null; endDate: string | null };
}) =>
  await axios.post(
    "https://wicked-pike-zipper.cyclic.cloud/api/sendMail",
    data,
  );
